import { FC } from 'react'
import * as styles from 'components/features/socialFeed/FeedPostList/FeedPostList.styl'
import { EmptyCardBlock } from 'components/features/pfm/Blocks/Blocks'
import Button from 'components/features/pfm/Button/Button'

type FeedPostListErrorState = {
  onTryAgain: () => void
}

export const FeedPostListErrorState: FC<FeedPostListErrorState> = (props) => {
  const { onTryAgain } = props

  return (
    <EmptyCardBlock shadowTheme='soft'>
      <p className={ styles.emptyPostListCopy }>
        Something went wrong. Please try again later.
      </p>
      <div className={ styles.zeroStateCtaWrapper }>
        <Button style='hollow' onClick={ onTryAgain }>
          Try Again
        </Button>
      </div>
    </EmptyCardBlock>
  )
}
